import { render, staticRenderFns } from "./CTTApproveAreaPromoterCRM.vue?vue&type=template&id=6ecd9fd2"
import script from "./CTTApproveAreaPromoterCRM.vue?vue&type=script&lang=js"
export * from "./CTTApproveAreaPromoterCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports